/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------------------
 * HDJ: coexist with the Essential Countdown Timer sticky top bar.
 *
 * The app prepends its bar to <body> with position:sticky; top:0; z-index:1
 * (it hard-codes z-index 1 for any timer created after 2023-10-19). Warehouse
 * then paints content over it, because these tie or beat z-index 1 and come
 * later in the DOM:
 *     .product-list                      z-index 1  (collection grid)
 *     .product-block-list__item--info    z-index 2  (product title)
 *     .collection__toolbar               z-index 3  (sticky under 999px)
 * and these sticky elements pin at top:0/20px, i.e. underneath the bar:
 *     #searchspring-sidebar, .card--sticky, .card--collapsed,
 *     .cart-recap__scroller, .collection__toolbar (under 999px)
 *
 * Fix: lift the bar to z-index 4 (above content, which maxes at 3; below the
 * header and drawers at 5 and modals at 10) and offset each sticky element by
 * the bar's live height, published as --hdj-topbar-h.
 *
 * IMPORTANT: target the stable class .essential_countdown_annoucement_bar_wrapper
 * (the app's own misspelling), NOT the per-timer class
 * .countdown_annoucement_bar_wrapper_<id>. A previous patch in assets/theme.css
 * used the per-timer class and silently stopped matching when the timer was
 * recreated on 2026-09-02, which is how this regressed.
 * ------------------------------------------------------------------------- */
(function () {
  var BAR = '.essential_countdown_annoucement_bar_wrapper';
  var root = document.documentElement;
  var resizeObserver = null;

  var css = [
    ':root{--hdj-topbar-h:0px}',
    BAR + '.top_page{z-index:4 !important}',
    '#searchspring-sidebar{top:calc(var(--hdj-topbar-h) + 20px) !important}',
    '.card--sticky,.card--collapsed{top:var(--hdj-topbar-h) !important}',
    '.cart-recap__scroller{top:var(--hdj-topbar-h) !important}',
    '@media screen and (max-width:999px){',
    '.collection__toolbar{top:calc(var(--hdj-topbar-h) + (var(--header-height, 0px) * var(--header-is-sticky, 0))) !important}',
    '}'
  ].join('');

  var style = document.createElement('style');
  style.id = 'hdj-topbar-offsets';
  style.appendChild(document.createTextNode(css));
  (document.head || root).appendChild(style);

  function measure() {
    var el = document.querySelector(BAR);
    var h = 0;
    if (el && getComputedStyle(el).position === 'sticky') {
      h = el.getBoundingClientRect().height;
    }
    root.style.setProperty('--hdj-topbar-h', Math.round(h) + 'px');
    if (el && window.ResizeObserver && !resizeObserver) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(el);
    }
  }

  function start() {
    measure();
    new MutationObserver(measure).observe(document.body, { childList: true });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
})();
